const mod = require('../bahabot.module.js')

class ContextMenuService {
    /**
     * @type {angular.IDeferred<string>}
     */
    _deferred = null;

    /**
     * @type {angular.IRootScopeService}
     */
    _$rootScope = null;

    /**
     * @type {angular.IQService}
     */
    _$q = null;

    /**
     * @type {boolean}
     */
    visible = false;

    /**
     * @type {{top: number, left: number}}
     */
    position = { top: 0, left: 0 }

    /**
     * @type {{key: string, label: string}[]}
     */
    actions = []

    /**
     * @type {number}
     */
    renderKey = 0;

    /**
     * 
     * @param {angular.IRootScopeService} $rootScope 
     * @param {angular.IQService} $q
     */
    constructor($rootScope, $q) {
        this._$q = $q;
        this._$rootScope = $rootScope;
    }

    /**
     * Renders the context menu in relation to the element triggering it with the menu actions provided.
     * Returns a promise that will resolve to the selected object, or reject if the menu was closed without making a choice.
     * @param {string} event 
     * @param {{key: string, label: string}[]} actions 
     */
    open(event, actions) {
        if (this._deferred) {
            this._deferred.reject();
        }

        this.renderKey++;
        this._deferred = this._$q.defer();

        this.visible = true;
        this.position = {top: event.pageY, left: event.pageX};
        this.actions = actions;
        this._$rootScope.$broadcast('bb-context-menu:open');

        return this._deferred.promise;
    }

    /**
     * Closes the context menu
     */
    close() {
        this.visible = false;
        this.actions = [];
        this.position = {top: 0, left: 0}
        this._$rootScope.$broadcast('bb-context-menu:close');
    }

    /**
     * Emits an event to the promise returned by open()
     * @param {string} value 
     */
    emit(value) {
        this._deferred?.resolve(value);
        this.close();
    }
}

/**
 * @param {angular.IRootScopeService} $rootScope
 * @param {angular.IQService} $q
 * @returns {ContextMenuService}
 */
function bbContextMenuService($rootScope, $q) {
    return new ContextMenuService($rootScope, $q);
}

mod.factory('ContextMenuService', ["$rootScope", "$q", bbContextMenuService]);
